import { render, staticRenderFns } from "./footer_nav.vue?vue&type=template&id=535cb5a9&scoped=true"
import script from "./footer_nav.vue?vue&type=script&lang=js"
export * from "./footer_nav.vue?vue&type=script&lang=js"
import style0 from "./footer_nav.vue?vue&type=style&index=0&id=535cb5a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535cb5a9",
  null
  
)

export default component.exports